/**
 * @file block list atoms
 */

import { atom } from 'jotai'

import { BlockStateEnum } from 'packages/feature-utils/test-paper'

/**
 * 当前聚焦的块 id，只有聚焦的块才有选中态和编辑状态
 */
export const focusedBlockAtom = atom<{
  id: number
  state: BlockStateEnum
}>({
  id: -1,
  state: BlockStateEnum.Display,
})

/**
 * 高亮效果的块，选中组（即标题）或者点击讨论通知定位到页面中的某个块的时候会有高亮效果
 */
export const highlightedBlockIdsAtom = atom<number[]>([])

/**
 * 当前收起的标题
 */
export const collapsedHeaderIdsAtom = atom<number[]>([])
